import React from "react"
import TargetPreciselyImage from "../../../../../components/staticQuery/platform/automation/TargetPreciselyImage"
import P from "../../../../../components/typography/P"
import TargetGraphic from "../../../../../images/platform/contact-management/filters-segmentation-targeting.svg"

const DescriptionText = () => (
  <>
    <P>
      Delivering the perfect message starts with selecting the right Contacts.
      MindMe allows you go easily segment your Contacts and target them
      precisely by Contact attribute, response or engagement.
    </P>
    <P>
      Type, List, Interest, Tag, Birthday, Offer redemption, Campaign activity,
      Mobile Page opens and more.
    </P>
  </>
)

const targetPreciselyData = {
  titleIcon: TargetGraphic,
  title: "Target Precisely",
  description: <DescriptionText />,
  graphic: <TargetPreciselyImage />,
  // imageLeft: false,
  textLong: false,
  benefits: [
    {
      benefitName: "Attributes like Type, List, Interest, Tag and Birthday",
    },
    {
      benefitName: "Response from Question, Poll, Feedback and Download",
    },
    { benefitName: "Offer Award, Redemption and Expiration" },
    { benefitName: "Campaign opens, Mobile Page clickes, etc." },
  ],
}

export default targetPreciselyData
